var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.87 229.84",
    style: {
      enableBackground: "new 0 0 425.87 229.84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;fill:#DBE8F7;}\r\n\t.st1{fill:#DEEBF8;}\r\n\t.st2{fill:#ACCBEB;}\r\n\t.st3{fill:#CCE0F4;}\r\n\t.st4{fill:#9EBFE5;}\r\n\t.st5{fill:#F79032;}\r\n\t.st6{fill:#FCC084;}\r\n\t.st7{fill:#73A2D6;}\r\n\t.st8{fill:#F4FBFE;}\r\n\t.st9{fill:#BDD0EC;}\r\n\t.st10{fill:#FFFFFF;}\r\n\t.st11{fill:#F79134;}\r\n\t.st12{fill:#FAAB77;}\r\n\t.st13{fill:#1E3966;}\r\n\t.st14{fill:#B73E38;}\r\n\t.st15{fill:#F79351;}\r\n\t.st16{fill:#234F9D;}\r\n\t.st17{fill:#4C9CAA;}\r\n\t.st18{fill:#1D3E73;}\r\n\t.st19{fill:#F47621;}\r\n\t.st20{opacity:0.6;}\r\n\t.st21{fill:#1A3763;}\r\n\t.st22{fill:#DEE9F7;}\r\n\t.st23{fill:#FEDCBB;}\r\n\t.st24{fill:#F8CBA6;}\r\n\t.st25{fill:#153154;}\r\n\t.st26{fill:#193D6C;}\r\n\t.st27{fill:#254790;}\r\n\t.st28{fill:#2E3555;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.97,223.44L405.97,223.44c-0.03,0.06-0.06,0.11-0.1,0.17c-0.23,0.41-0.46,0.82-0.7,1.23l-366.01-0.11 c0,0-0.36-0.4-0.99-1.16c-0.04-0.04-0.07-0.09-0.11-0.13c-1.63-1.96-4.93-6.09-8.78-11.92c0,0,0,0,0-0.01 c-10.22-15.46-24.38-42.84-22-73.22c0.67-8.58,2.66-17.39,6.43-26.25c11.43-26.86,45.54-44.97,76.27-45.33 c11.89-0.14,23.28,2.38,32.65,8.07c1.66,1.01,3.75,1.79,6.18,2.32c2.05,0.45,4.34,0.72,6.82,0.81 c19.96,0.7,52.41-10.54,71.66-38.84c10.22-15.03,25.92-24.86,43.95-29.98c0.84-0.24,1.69-0.47,2.54-0.68 c4.1-1.05,8.32-1.87,12.6-2.45c0.77-0.1,1.55-0.2,2.32-0.29c19.03-2.21,39.42,0.08,58.12,6.39c2.46,0.83,4.9,1.73,7.29,2.7 c35.19,14.25,62.56,43.35,60.16,83.98c-0.1,1.61-0.24,3.23-0.43,4.87c-0.36,3.13-0.9,6.32-1.61,9.58 c-0.42,1.92-0.91,3.86-1.46,5.82C376.28,170.52,434.26,172.84,405.97,223.44z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.97,223.44L405.97,223.44l-284.9,0.03l2.46-85.14v-23.13h10.66V97.12h21.26v15.34h6.49V84.1h1.41v-1.98 h0.25v1.98h5.13v-1.98h0.25v1.98h7.26v-1.98h0.25v1.98h4.57v-1.98h0.25v1.98h1.88v26.48h7.18v-4.28l8.46,0.04v-6.94h1.7v-1.37 h0.23v1.37h6.53v0h1.31v-1.38h0.22v1.38h1.58v13.8h10.07v5.08h5.6v-2.95h5.19v-11.71h2.59v-5.46h0.39v5.46h6.21V93.38h0.61v10.24 h4.11v-0.14h-0.01v-1.3h0.01v-1.23h-0.01v-2.05h0.01v-1.31h-0.01v-2.05h0.01v-1.31h-0.01v-2.05h0.01v-1.41h-0.01v-2.04h0.01v-1.8 h-0.01v-2.04h0.01v-1.36h1.22V82h0.2v1.53h9.07V82h0.19v1.53h1.66v10.7l1.16,0.01v-0.01h-0.01v-2.05h0.01v-1.41h-0.01v-2.04h0.01 v-1.41h-0.01v-2.05h0.01v-0.01h10.99v0.01h1.89c0.1,0.05,0.2,0.11,0.29,0.16v13.65h2.02v-1.97h23.2v15.34h7.09V84.1h1.54v-1.98 h0.28v1.98h5.59v-1.98h0.28v1.98h7.92v-1.98h0.28v1.98h4.99v-1.98h0.28v1.98h2.05v26.48h7.83v-4.28l9.23,0.04v-6.94h1.86v-1.37 h0.25v1.37h7.13v0h1.43v-1.38h0.25v1.38h1.72v13.8h10.99v5.08h6.11v-2.95h5.67v-11.71h2.83v-5.46h0.43v5.46h6.78V93.38h0.66v10.23 h3.33c-0.36,3.13-0.9,6.32-1.61,9.58c-0.42,1.92-0.91,3.86-1.46,5.82C376.28,170.52,434.26,172.84,405.97,223.44z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.13,14.76v208.68h-7.29V12.05C329.3,12.89,331.73,13.79,334.13,14.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M128.81,77.11v146.46H38.16c-0.04-0.04-0.07-0.09-0.11-0.13c-1.63-1.96-4.93-6.09-8.78-11.92c0,0,0,0,0-0.01 c-10.22-15.46-24.38-42.84-22-73.22c0.67-8.58,2.66-17.39,6.43-26.25c11.43-26.86,45.54-44.97,76.27-45.33 c11.78,0.13,23.01,2.67,32.34,8.07C124.06,75.79,126.25,76.57,128.81,77.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268.71,5.66v25.7c0,2-0.49,3.64-1.09,3.64h-0.16c-0.6,0-1.08-1.63-1.08-3.64V5.95 C267.16,5.85,267.94,5.75,268.71,5.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M266.95,28.82c-8.47,0-15.34,7.26-15.34,16.22h30.67C282.28,36.08,275.42,28.82,266.95,28.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M268.17,29.02c-0.44-0.1-0.89-0.15-1.35-0.15c-5.52,0-9.99,7.24-9.99,16.16h2.69 C259.52,36.85,263.29,30.08,268.17,29.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.94,199.52c0,0-4.08-4.76-0.25-7.79c0,0,2.8-1.69,5.08-1.56c0,0-3.23,5.42-2.19,5.96 c1.05,0.54,3.17-6.3,3.17-6.3s6.37-0.62,8.41,0.37c0,0-5.44,4.45-4.3,4.72c1.15,0.27,7.02-4.11,7.02-4.11s5.92,1.01,5.61,4.62 c-0.32,3.61-2.36,4.73-3.25,4.63c-0.9-0.1-6.15-2.1-6.26-1.36c-0.11,0.74,3.05,3.14,5.26,3.25c0,0-4.18,4.61-6.95,3.28 c-2.78-1.33-3.01-3.44-4.74-4.23c-1.73-0.79-3.21-0.79-2.49,0.02c0.71,0.81,3.85,1.59,4.84,3.34c0.99,1.75,1.88,2.93-0.99,2.5 c-2.87-0.43-7.54-2.53-7.75-4.94C367.94,199.52,367.94,199.52,367.94,199.52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M387.59,195.54c0,0-16.09-0.62-19.64,3.98c0,0-0.79,2.35-3.2,4.5l-0.38,1.03c0,0,2.79-2.94,3.79-3.12 C368.15,201.93,366.59,196.22,387.59,195.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M364.74,204.02c0,0-3.45,2.55-3.69,7.12l0.63,0.06c0,0,1.1-4.72,3.1-6.56 C366.76,202.78,364.74,204.02,364.74,204.02z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M353.67,193.53c0,0,6.49-3.64,3.46-8.57c0,0-2.42-3.03-5.02-3.81c0,0,1.39,7.36,0,7.53 c-1.38,0.17-0.95-8.31-0.95-8.31s-6.84-3.29-9.52-3.03c0,0,4.24,7.18,2.86,7.01s-6.15-7.44-6.15-7.44s-7.01-1.3-8.14,2.86 c-1.13,4.15,0.69,6.23,1.73,6.49c1.04,0.26,7.7,0.17,7.53,1.04c-0.17,0.87-4.67,2.25-7.18,1.47c0,0,2.77,6.84,6.41,6.49 c3.64-0.35,4.76-2.6,7.01-2.77c2.25-0.17,3.9,0.43,2.77,1.04c-1.13,0.61-4.93,0.2-6.75,1.74c-1.82,1.55-3.29,2.5,0.09,3.19 c3.38,0.69,9.44,0.26,10.65-2.34C353.67,193.53,353.67,193.53,353.67,193.53z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M333.42,181.07c0,0,18.18,5.89,20.26,12.46c0,0-0.09,2.94,1.73,6.32v1.3c0,0-1.9-4.41-2.94-5.02 C352.46,196.13,356.53,190.42,333.42,181.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355.4,199.85c0,0,2.8,4.26,1.21,9.44l-0.72-0.19c0,0,0.7-5.71-0.77-8.58 C353.65,197.65,355.4,199.85,355.4,199.85z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M364,188.52c0,0-8.56-4.79-4.56-11.3c0,0,3.19-3.99,6.62-5.02c0,0-1.83,9.7,0,9.93 c1.83,0.23,1.26-10.95,1.26-10.95s9.01-4.34,12.55-3.99c0,0-5.59,9.47-3.77,9.24c1.83-0.23,8.1-9.81,8.1-9.81 s9.24-1.71,10.73,3.77c1.48,5.48-0.91,8.22-2.28,8.56c-1.37,0.34-10.16,0.23-9.93,1.37c0.23,1.14,6.16,2.97,9.47,1.94 c0,0-3.65,9.01-8.44,8.56c-4.79-0.46-6.28-3.42-9.24-3.65c-2.97-0.23-5.13,0.57-3.65,1.37c1.48,0.8,6.5,0.26,8.9,2.3 s4.34,3.29-0.11,4.21c-4.45,0.91-12.44,0.34-14.03-3.08C364,188.52,364,188.52,364,188.52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M390.7,172.09c0,0-23.96,7.76-26.7,16.43c0,0,0.11,3.88-2.28,8.33v1.71c0,0,2.51-5.82,3.88-6.62 C365.6,191.94,360.24,184.41,390.7,172.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M361.72,196.85c0,0-3.7,5.61-1.59,12.44l0.95-0.26c0,0-0.92-7.52,1.01-11.31 C364.02,193.94,361.72,196.85,361.72,196.85z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M363.71,224.1c9.26,0,16.76-7.51,16.76-16.76h-33.53C346.95,216.6,354.45,224.1,363.71,224.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.84,223.97c-0.68,0.09-1.38,0.13-2.08,0.13c-9.26,0-16.76-7.51-16.76-16.76h4.16 C353.16,215.89,359.56,222.95,367.84,223.97z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.4,
    y: 207.34,
    className: "st4",
    width: 34.46,
    height: 0.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M285.67,223.28l-16.47-68.37l1.15-2.69l16.32,71.05c0.04,0.18-0.1,0.36-0.28,0.36h-0.27 C285.9,223.63,285.72,223.48,285.67,223.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M211.33,223.63L211.33,223.63c-0.34,0-0.6-0.3-0.54-0.64l4.85-29.41h2.08l-5.79,29.55 C211.88,223.42,211.63,223.63,211.33,223.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M257.87,223.63L257.87,223.63c-0.34,0-0.6-0.3-0.54-0.64l4.85-29.41h2.08l-5.79,29.55 C258.42,223.42,258.17,223.63,257.87,223.63z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "269.16,193.64 211.22,193.64 223.22,118.39 281.16,118.39  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.95,
    y: 193.07,
    className: "st7",
    width: 66.54,
    height: 2.21
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M246.17,134.13c-0.04,0.6-0.13,1.18-0.26,1.75c-1.21,5.38-6,9.5-11.41,9.51 c-5.99,0.01-10.47-5.01-10.01-11.22c0.46-6.21,5.68-11.25,11.67-11.26c1.26,0,2.44,0.22,3.54,0.62c0.49,0.18,0.96,0.4,1.41,0.65 c0.97,0.55,1.83,1.26,2.56,2.1c0.41,0.47,0.77,0.97,1.09,1.51c0.18,0.31,0.35,0.64,0.5,0.97c0.42,0.93,0.71,1.94,0.85,3.01 c0.07,0.53,0.1,1.08,0.1,1.65C246.19,133.66,246.18,133.89,246.17,134.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M245.25,128.77l-9.92,5.38c0,0,4.09-7.21,5.78-9.96c0.97,0.55,1.83,1.26,2.56,2.1 c0.41,0.47,0.77,0.97,1.09,1.51C244.93,128.11,245.1,128.44,245.25,128.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M246.28,127.41l-9.06,4.91c0,0,3.74-6.59,5.28-9.1c0.89,0.5,1.67,1.15,2.34,1.92 c0.37,0.43,0.7,0.89,0.99,1.38C245.99,126.81,246.14,127.1,246.28,127.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M264.54,187.92l-47.69,0l4.83-27.52l47.69,0L264.54,187.92z M217.24,187.64l47.02,0l4.73-26.96l-47.02,0 L217.24,187.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M261.7,184.15l-42.3,0c0,0,7.5-4.02,9.56-3.81c2.06,0.21,5.02,1.84,6.92,1.9 c1.9,0.06,3.96-5.65,6.08-5.38c2.12,0.27,2.91,5.32,4.01,4.83c1.1-0.49,4.39-0.71,6.28,0c1.9,0.71,4.66-2.25,6.33-2.16 C260.25,179.62,261.7,184.15,261.7,184.15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "229.57,176.06 221.5,176.06 221.57,175.63 229.65,175.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "229.41,176.98 221.33,176.98 221.41,176.55 229.49,176.55  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M221.82,170.35l42.3,0c0,0-6.09-4.02-8.22-3.81c-2.13,0.21-5.66,1.84-7.59,1.9 c-1.92,0.06-1.98-5.65-4.19-5.38c-2.21,0.27-4.78,5.32-5.7,4.83c-0.92-0.49-4.14-0.71-6.28,0c-2.14,0.71-3.87-2.25-5.57-2.16 C224.86,165.83,221.82,170.35,221.82,170.35z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "231.86,163.06 223.78,163.06 223.85,162.63 231.93,162.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "231.7,163.97 223.62,163.97 223.69,163.54 231.77,163.54  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "224.57,156.57 222.71,156.57 224.32,147.87 226.18,147.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "227.09,156.57 225.24,156.57 226.49,149.83 228.34,149.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "229.62,156.57 227.77,156.57 229.07,149.54 230.92,149.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "232.15,156.57 230.29,156.57 231.28,151.22 233.14,151.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "234.67,156.57 232.82,156.57 233.88,150.83 235.74,150.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "237.2,156.57 235.35,156.57 236.17,152.12 238.03,152.12  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "249.38,156.57 247.53,156.57 249.14,147.87 250.99,147.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "251.91,156.57 250.05,156.57 251.3,149.83 253.16,149.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "254.44,156.57 252.58,156.57 253.88,149.54 255.74,149.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "256.96,156.57 255.11,156.57 256.1,151.22 257.95,151.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "259.49,156.57 257.64,156.57 258.7,150.83 260.55,150.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "262.02,156.57 260.16,156.57 260.99,152.12 262.84,152.12  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "258.31,128.19 252.28,128.19 252.43,127.36 258.47,127.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "265.72,128.19 259.05,128.19 259.21,127.36 265.88,127.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "270.48,128.19 266.22,128.19 266.38,127.36 270.63,127.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "274.44,128.19 271.16,128.19 271.32,127.36 274.6,127.36  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "257.65,131.72 251.61,131.72 251.77,130.89 257.81,130.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "265.06,131.72 258.39,131.72 258.55,130.89 265.22,130.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "269.81,131.72 265.56,131.72 265.72,130.89 269.97,130.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "273.78,131.72 270.5,131.72 270.66,130.89 273.94,130.89  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "261.9,126.26 252.64,126.26 252.79,125.43 262.06,125.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "268.13,126.26 262.79,126.26 262.94,125.43 268.28,125.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "274.81,126.26 268.88,126.26 269.04,125.43 274.97,125.43  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "261.2,130.01 251.93,130.01 252.09,129.18 261.35,129.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "267.42,130.01 262.08,130.01 262.24,129.18 267.58,129.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "274.11,130.01 268.18,130.01 268.33,129.18 274.26,129.18  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "256.99,135.25 250.95,135.25 251.11,134.42 257.14,134.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "264.4,135.25 257.73,135.25 257.88,134.42 264.55,134.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "269.15,135.25 264.9,135.25 265.05,134.42 269.3,134.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "273.12,135.25 269.84,135.25 269.99,134.42 273.27,134.42  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "260.54,133.54 251.27,133.54 251.43,132.71 260.69,132.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "266.76,133.54 261.42,133.54 261.57,132.71 266.91,132.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "273.44,133.54 267.51,133.54 267.67,132.71 273.6,132.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "256.37,138.56 250.33,138.56 250.48,137.73 256.52,137.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "263.78,138.56 257.11,138.56 257.26,137.73 263.93,137.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "268.53,138.56 264.28,138.56 264.43,137.73 268.68,137.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "272.5,138.56 269.22,138.56 269.37,137.73 272.65,137.73  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "259.91,136.85 250.65,136.85 250.8,136.02 260.07,136.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "266.14,136.85 260.8,136.85 260.95,136.02 266.29,136.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "272.82,136.85 266.89,136.85 267.05,136.02 272.98,136.02  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "242.62,149.16 239.67,149.16 239.74,148.76 242.7,148.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "246.25,149.16 242.99,149.16 243.06,148.76 246.33,148.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "242.3,150.89 239.34,150.89 239.42,150.49 242.38,150.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "245.93,150.89 242.66,150.89 242.74,150.49 246,150.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "244.38,148.22 239.85,148.22 239.92,147.82 244.46,147.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "247.43,148.22 244.81,148.22 244.89,147.82 247.5,147.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "244.04,150.06 239.5,150.06 239.58,149.65 244.11,149.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "247.08,150.06 244.47,150.06 244.54,149.65 247.16,149.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "266.3,149.16 263.35,149.16 263.42,148.76 266.38,148.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "269.93,149.16 266.66,149.16 266.74,148.76 270,148.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "265.98,150.89 263.02,150.89 263.1,150.49 266.05,150.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "269.6,150.89 266.34,150.89 266.42,150.49 269.68,150.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "268.06,148.22 263.52,148.22 263.6,147.82 268.14,147.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "271.11,148.22 268.49,148.22 268.57,147.82 271.18,147.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "267.71,150.06 263.18,150.06 263.26,149.65 267.79,149.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "270.76,150.06 268.15,150.06 268.22,149.65 270.84,149.65  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M282.03,222.51c-0.1,1.41-2.1,1.43-4.36,1.17c-2.26-0.26-1.66,0.31-4.83,0.35c-3.17,0.04-4.26-1-4.42-1.46 c-0.14-0.4,1.39-0.74,3.02-1.14c0.21-0.05,0.41-0.1,0.62-0.15c1.84-0.47,3.06-1.85,4.64-3.05c1.49-1.14,3.42-5.27,3.42-5.27 l4.33-0.2c0,0-1.82,3.7-2.51,5.3c-0.4,0.94-0.23,2.09-0.06,2.98C281.97,221.52,282.07,222.01,282.03,222.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M277.66,223.68c-2.26-0.26-1.66,0.31-4.83,0.35c-3.17,0.04-4.26-1-4.42-1.46c-0.14-0.4,1.39-0.74,3.02-1.14 l0.02,0.03c0,0,2.04,1.1,4.65,0.83c2.13-0.21,4.3-1.1,5.77-1.26c0.09,0.48,0.19,0.97,0.15,1.47 C281.92,223.93,279.93,223.94,277.66,223.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M311.95,222.8c-0.1,1.41-2.1,1.43-4.36,1.17c-2.27-0.26-1.66,0.31-4.83,0.36c-3.17,0.05-4.27-1-4.42-1.45 c-0.14-0.4,1.39-0.74,3.02-1.14c0.21-0.05,0.41-0.1,0.62-0.15c1.84-0.47,3.06-1.85,4.64-3.06c1.49-1.14,0-7.9,0-7.9l4.76-0.46 c0,0-0.23,5.69-0.23,8.28c0,1.02,0.47,2,0.65,2.89C311.89,221.81,311.98,222.31,311.95,222.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M307.58,223.98c-2.27-0.26-1.66,0.31-4.83,0.36c-3.17,0.05-4.27-1-4.42-1.45c-0.14-0.4,1.39-0.74,3.02-1.14 l0.02,0.03c0,0,2.04,1.09,4.65,0.83c2.13-0.22,4.3-1.11,5.77-1.27c0.09,0.48,0.19,0.97,0.15,1.47 C311.85,224.22,309.85,224.24,307.58,223.98z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M298.04,105.95c-0.82-3.37,0.37-4.94,1.44-5.78c0.51-1.24,1.09-2.14,1.68-2.47 c1.08-0.62,2.38-0.68,3.29-0.63c-0.23-0.24-0.69-0.33-0.69-0.33c0.56-0.08,1.82,0.47,1.82,0.47c7.83-3.02,9.06,8.51,8.9,11.19 c-0.16,2.68-0.14,5.83,3.93,7.94c7.77,4.03-2.58,19.2-2.58,19.2c0.2-2.16-9.79-13.59-15-17.01c-1.27-1.87-1.72-5.17-1.75-5.43 c0.22,2.62,0.67,4.08,1.07,4.91C297.77,115.83,297.41,110.58,298.04,105.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M301.13,118.7c-0.03,0.01,2.52,1.33,4.43,0.81c1.8-0.49,2.97-2.82,2.95-2.83c-0.76-0.15-0.98-1.2-0.96-5.69 l-0.34,0.07l-5.79,1.15c0,0,0.13,1.82,0.14,3.54C301.55,117.18,301.46,118.55,301.13,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M301.41,112.21c0,0,0.13,1.82,0.14,3.54c3.24-0.09,4.95-3.05,5.65-4.68L301.41,112.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M277.86,215.26c-0.28,0.89,0.35,1.81,1.29,1.85l2.26,0.11l2.39,0.07c0.6,0.02,1.17-0.24,1.55-0.71 c1.91-2.34,7.79-10.15,11.36-21.5c0.1-0.32,0.21-0.64,0.32-0.97c2.36-6.87,7.24-15.49,9.81-23.29c0.41-1.24,0.78-2.41,1.11-3.52 c0.11-0.35,0.21-0.7,0.31-1.05c1.9-6.59,2.45-10.91,2.95-15.54l-18.58,0.15C292.62,150.87,288.71,181.27,277.86,215.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M295.22,140.2c0.05,8.84-1.3,12.63-1.3,12.63s7.95,4.04,17.41,1.07c0.11-0.04,6.76-1.92,6.76-1.92 c-0.16-0.36-1.47-6.27-1.63-6.6c-2-4.29-2.54-6.09-2.78-7.4c-0.44-2.46-0.45-5.01-0.23-7.41c0.58-6.36,2.29-11.63,2.29-11.63 c-2.58-0.59-4.99-1.62-7.67-2.62c-0.62,0.77-2.5,1.57-4.14,1.53c-1.88-0.04-2.49-0.85-2.4-1.73c-2.01,1.12-3.61,2.17-3.61,2.17 c-1.71,2.96-5.17,5.84-5.42,10.38C292.47,129.79,295.22,139.95,295.22,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M311.2,141.18c0.81,1.15,2.37,8.14,6.24,9.01c-2-4.98-3.51-7.16-3.75-8.69c-0.44-2.86-0.45-5.81-0.23-8.6 c-1.3-2.27-2.26-3.83-2.26-3.83c-0.1-0.37-2.06-6.42-2.69-1.01C307.88,133.47,310.29,139.9,311.2,141.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M300.33,113.83c0,0,7.66,0.13,7.67-4.65c0.01-4.77,1-7.97-3.9-8.26c-4.89-0.28-5.85,1.54-6.24,3.13 C297.48,105.65,298.34,113.67,300.33,113.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M300.61,100.81c0,0,2.1,5.6,5.32,6.43c3.22,0.83,4.62-0.03,4.62-0.03s-2.47-1.96-2.98-5.39 C307.57,101.82,302.2,98.14,300.61,100.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M301.13,101.27c0,0-1.57,1.25-1.95,2.47c-0.38,1.22-0.55,3.72-1.28,3.63c0,0-1.58-3.81,0.2-5.96 C299.98,99.12,301.13,101.27,301.13,101.27z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "288.27,146.33 284.65,157.37 286.72,158.2 292.7,148.45  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M298.03,117.64c0,0-4.27,1.69-5.5,4.33c-1.24,2.64-3.11,20.35-3.85,22.17c-0.74,1.82-1.31,3.26-1.31,3.26 s2.15,1.81,4.32,1.95C293.85,149.49,298.03,117.64,298.03,117.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M301.55,116.12c0,0-4.43,10.95-4.56,13.17c-0.13,2.22-0.52,36.25-0.52,36.25s0.26,1.56-2.74,0.91 c-3-0.65-3.78-1.3-3.78-1.3s2.87-21,2.09-28.3c-0.78-7.3,6-19.21,6-19.21L301.55,116.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M281.41,217.21l2.6,0.08c0.46,0.01,0.91-0.19,1.2-0.54c1.75-2.11,7.84-10.03,11.49-21.67 c0.1-0.32,0.21-0.64,0.32-0.97c2.36-6.87,7.24-15.49,9.81-23.29c0.41-1.24,0.78-2.41,1.11-3.52c0.11-0.35,0.21-0.7,0.31-1.05 l-2.74-2.08c0,0-8.21,13.3-10.76,25.82C292.55,200.88,283.7,213.96,281.41,217.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M305.23,191.17c-0.04,5.76,0.23,18.59,0.93,24.87c0.06,0.57,0.55,1.01,1.13,1.01h1.94 c0.82,0,1.43-0.01,1.83-0.01c0.35-0.01,0.65-0.26,0.72-0.6c1.93-9.81,3.31-17.96,4.32-25c0.85-5.89,1.6-10.95,2.17-15.3 c0.58-4.38,0.99-8.04,1.13-11.14c0.02-0.49,0.04-0.96,0.05-1.42c0.01-0.46,0.01-0.91,0.01-1.35l-16.05-1.56 C303.6,171.32,305.25,187.63,305.23,191.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M309.22,217.05c0.73,0,1.3,0,1.7-0.01c0.43-0.01,0.79-0.31,0.87-0.73c1.91-9.75,3.29-17.86,4.29-24.88 c0.85-5.89,1.6-10.95,2.17-15.3c0.58-4.38,0.99-8.04,1.13-11.14l-5.89,3.46c0,0,3.76,1.33,2.33,11.37 C314.4,189.86,311.22,215.62,309.22,217.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M308.46,164.89c0,0,1.13,4.09,5.04,3.56c3.91-0.52,9.48-2.87,9.48-2.87s-1.67-5.28-3.75-12.22 c-2.52-8.4-5.63-19.23-7.1-26.07c-0.41-1.91-0.69-3.51-0.8-4.66l-3.25-6.3c0,0-4.84,10.86-5.1,13.6 C302.73,132.68,308.46,164.89,308.46,164.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M312.37,129.53l-4.28-13.19c0.01,0.01,5.41,1.61,8.13,2.98c0,0,1.7,2.19,2.75,7.24 c0,0,1.11,12.12-1.37,16.56c0,0-7.82,1.56-20.34-2.74v-2.87c0,0,13.69,0.72,16.5,1.04L312.37,129.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M308.64,135.68c0.17,4.43,1.22,13.04,10.52,17.65c0.02,0.01,0.05,0.02,0.07,0.04 c-2.52-8.4-5.63-19.23-7.1-26.07C310.42,129.85,308.54,133.24,308.64,135.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M308.09,116.34c0,0,7.94,0.56,9.85,4.82c1.91,4.26,2.52,18.43,0.09,22.6c0,0-3.35,0.95-9.28-0.15 c-0.07-0.01-0.15-0.03-0.22-0.04c0,0-1.89-4.63-0.2-5.54c0,0,5,0.26,4.48-1.39C312.29,134.98,308.09,116.34,308.09,116.34z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M288.18,139.28l0.23,0.75l13.03-4.05c0,0,0.17-0.2,0.09-0.46c-0.09-0.29-0.32-0.29-0.32-0.29L288.18,139.28 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "287.23,139.99 288.18,139.28 288.41,140.03  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M285.17,157.07c0,0-3.31,1.83-3.74,3.22c-0.44,1.39-0.14,4.31,0.39,4.26c0.52-0.04,1.31-3.13,1.74-3.35 c0.43-0.22,1.04-0.87,1.04-0.39c0,0.48-0.43,1.35-0.22,1.48c0.22,0.13,0.91-1.22,1.39-1.48c0.48-0.26,0.68-2.41,1.14-2.99 C287.38,157.24,285.17,157.07,285.17,157.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M297.25,137.51c0,0-2.96-1.82-4.2-1.54c-1.24,0.28-4.4,2.57-2.88,3.06c1.52,0.5,2.75-0.02,3.34,0.34 c0.58,0.36,1.02,1.02,3.74,1.01C299.97,140.37,297.25,137.51,297.25,137.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M154.08,223.62h-0.05c-0.29,0-0.52-0.24-0.51-0.52l0.78-33.64l2.29-0.27l-1.95,33.91 C154.62,223.39,154.37,223.62,154.08,223.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M140.76,223.62h-0.05c-0.29,0-0.52-0.24-0.51-0.52l0.78-33.64l2.29-0.27l-1.95,33.91 C141.29,223.39,141.05,223.62,140.76,223.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M177.52,223.62h0.05c0.29,0,0.52-0.24,0.51-0.52l-0.78-33.64l-2.29-0.27l1.95,33.91 C176.99,223.39,177.23,223.62,177.52,223.62z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M139.24,187.37v-23.05c0-4.06,3.29-7.34,7.34-7.34h16.61c4.06,0,7.34,3.29,7.34,7.34v23.93L139.24,187.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M173.52,191.01h-30.63c-2.01,0-3.64-1.63-3.64-3.64l0,0h34.27V191.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M177.17,191.01h-23.88c-1,0-1.82-0.81-1.82-1.82l0,0c0-1.01,0.81-1.82,1.82-1.82h23.88 c1.01,0,1.82,0.81,1.82,1.82v0C178.99,190.2,178.18,191.01,177.17,191.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M195.51,210.21c0.23,1.16,1.88,0.97,3.73,0.51c1.85-0.45,1.41,0.09,4.03-0.21s3.42-1.27,3.5-1.66 c0.07-0.35-1.23-0.47-2.62-0.63c-0.18-0.02-0.35-0.04-0.53-0.06c-1.57-0.2-2.72-1.21-4.15-2.04c-1.35-0.79-3.37-4-3.37-4 l-3.6,0.29c0,0,1.89,2.87,2.62,4.12c0.43,0.73,0.41,1.7,0.35,2.45C195.46,209.38,195.43,209.8,195.51,210.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.24,210.72c1.85-0.45,1.41,0.09,4.03-0.21s3.42-1.27,3.5-1.66c0.07-0.35-1.23-0.47-2.62-0.63 l-0.01,0.03c0,0-1.57,1.12-3.76,1.17c-1.78,0.04-3.67-0.47-4.9-0.45c-0.03,0.41-0.05,0.82,0.03,1.23 C195.74,211.37,197.39,211.17,199.24,210.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M164.56,215.39c-0.72,0.94,0.52,2.05,2.08,3.14c1.56,1.09,0.87,1.11,2.82,2.89 c1.96,1.78,3.22,1.73,3.56,1.53c0.31-0.18-0.46-1.23-1.26-2.38c-0.1-0.14-0.2-0.29-0.3-0.44c-0.89-1.31-0.89-2.84-1.21-4.46 c-0.3-1.54,2.21-7.18,2.21-7.18l-4.03-0.51c0,0-0.53,3.41-0.98,4.78c-0.27,0.81-1.39,1.34-1.98,1.8 C165.14,214.8,164.81,215.06,164.56,215.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M166.64,218.53c1.56,1.09,0.87,1.11,2.82,2.89c1.96,1.78,3.22,1.73,3.56,1.53 c0.31-0.18-0.46-1.23-1.26-2.38l-0.03,0.01c0,0-1.88-0.44-3.36-2.05c-1.21-1.31-2.08-3.06-2.91-3.97 c-0.32,0.25-0.65,0.5-0.91,0.84C163.84,216.33,165.08,217.44,166.64,218.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M181.01,186.54l-3.68,9.9l-4.8,12.93c0,0-1.3,0.13-2.55-0.23c-1.15-0.33-2.47-1.2-2.47-1.2 s1.33-13.88,3.82-21.85c0.64-2.05,1.35-3.7,2.14-4.63C177.33,176.89,181.01,186.54,181.01,186.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M177.27,170.81c-2.41-0.78-9.68-0.31-16.58,1.04l-1.06-1.85l-14.92-1.17c0,0-4.92,10.92-2.23,17.87 c0.4,1.02,1.18,1.68,2.53,1.7c0,0,0.22,0,0.22,0c0,0,8.88-0.01,11.76-0.01c7.42,0,15.7-5.1,16.77-5.31 c1.75-0.35,2.46,3.16,4.21,6.84c1.75,3.68,16.49,16.31,16.49,16.31s2.26,0.02,3.2-0.33c1.01-0.38,1.37-0.87,1.37-0.87 S182.71,172.56,177.27,170.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.41,124.84c-2.1-0.5-4.95,0.09-5.42,0.14c-5.67,0.66-6.93,9.46-6.51,11.92c0.78,4.54-1.4,5.81-4,9.44 c-5.21,7.28-1.61,13.27,2.63,14.75c2.55,0.89,6.02-1.53,6.02-1.53c0.06,0.02,9.01-8.52,13.43-12.66 C167.99,143.84,159.76,126.11,154.41,124.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M155.62,145.59c0.03,0.01-2.31,1.53-4.21,1.21c-1.79-0.3-3.68-2.63-3.66-2.64 c0.72-0.22,1.36-1.06,0.91-5.42l0.34,0.03l5.72,0.55c0,0,0.05,1.78,0.21,3.44C155.07,144.16,155.29,145.47,155.62,145.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M154.72,139.32c0,0,0.05,1.78,0.21,3.44c-3.15,0.23-5.09-2.47-5.93-3.99L154.72,139.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M155.93,140.79c0,0-7.41,0.87-7.88-3.76c-0.47-4.62-1.74-7.62,2.97-8.37c4.71-0.75,5.81,0.92,6.34,2.43 S157.84,140.45,155.93,140.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M156.48,128.72c0,0-3.58,5.12-6.62,6.24c-3.04,1.11-4.47,0.41-4.47,0.41s1.45-2,1.93-4.74 c0.14-0.81,0.7-1.48,1.48-1.75C150.97,128.11,155.17,126.95,156.48,128.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.52,129.1c0,0,1.91,1.09,2.68,2.07c0.74,0.94,1.52,3.45,1.41,4.55c0,0,1.2-5.26-0.72-7.17 C154.84,126.52,153.52,129.1,153.52,129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M161.32,157.85c-0.22,14.96-0.06,11.84-1.7,13.26c-0.39,0.34-1.5,0.55-2.96,0.64 c-4.59,0.3-12.65-0.45-12.96-1.3c-1.06-2.93-0.31-3.85-1.19-8.34c-0.09-0.48-0.21-0.99-0.34-1.56c-0.74-3.09-1.45-4.13,1.16-9.09 c2.37-4.49,4.93-8.08,5.15-7.95c6.25,3.71,6.66,0.53,6.66,0.53S161.43,150.55,161.32,157.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M177.33,196.44l-4.91,13.47c0,0-1.77,0.57-3.05,0.39c-1.31-0.19-2.03-0.91-2.03-0.91s1.5-15.34,3.99-23.31 L177.33,196.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M155.13,144.05c0,0,6.43,1.09,7.19,3.86c0.76,2.77,6.28,18.03,6.28,18.03s-4.35,1.61-5.86,0.1 c-1.51-1.51-5.25-14.01-5.25-14.01L155.13,144.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M156.66,171.75c-4.59,0.3-12.65-0.45-12.96-1.3c-1.06-2.93-0.31-3.85-1.19-8.34l2.15-4.9 c0,0-0.3,5.61,1.74,7.43c2.04,1.83,8.38,3.52,9.37,5.05C156.25,170.43,156.56,171.16,156.66,171.75z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M157.03,168.56c0,0,1.37,1.18,1.76,1.27c0.39,0.1,0.61,0.01,0.61,0.01l-1-1.17L157.03,168.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M156.49,167.17l3.46,0.89c0,0-0.09,0.25-0.48,0.31c-0.39,0.06-1.44-0.1-1.44-0.1L156.49,167.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M150.62,169.08c0,0,4.94-2.2,5.87-1.91c0.93,0.29,3.3,1.55,3.68,2.08c0.37,0.53-1.95-0.07-2.67-0.11 c-0.47-0.03-1.56,0.61-2.1,0.93c-2.28,1.31-3.86,1.19-3.86,1.19L150.62,169.08z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M148.47,143.52c0,0-6.99,1.31-8.28,3.25c-2.82,4.23-8.84,21.74-5.47,24.09c3.79,2.64,17.26,0.69,17.26,0.69 s0.45-2.09-0.18-3.11c-0.62-1.01-10.76-2.65-11.22-3.12c-0.47-0.47,4.62-7.23,4.08-8.52 C142.92,152.65,148.47,143.52,148.47,143.52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M176.1,168.33c0,0,4.89,1.32,5.39,2.08c0.5,0.76,1.49,3.08,1.45,3.69c-0.04,0.61-1.38-1.2-1.88-1.66 c-0.32-0.3-1.5-0.47-2.07-0.57c-1.45-0.24-2.15-0.9-2.7-1.23c-0.37-0.22-0.81-0.18-0.81-0.18L176.1,168.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M181.06,171.74c0,0,0.3,1.66,0.52,1.96c0.23,0.3,0.44,0.37,0.44,0.37l-0.03-1.44L181.06,171.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M181.49,170.41l1.99,2.69c0,0-0.21,0.13-0.53-0.06c-0.32-0.19-0.99-0.92-0.99-0.92L181.49,170.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M176.28,170.64c0,0,0.45,1.1,1.36,1.5c0.91,0.39,1.57,0.99,1.72,0.77c0.15-0.21-0.69-1.33-0.69-1.33 L176.28,170.64z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M167.29,162.33l10.29,6.5c0,0-1.08,1.45-1.44,1.58c-1.9,0.7-10.47,0.03-13.4-4.38L167.29,162.33z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M163.21,169.4c0.61,0,6.64-0.42,6.64-0.42s-0.17,1.07,0.2,1.64l-5.88,1.13l-1.21-0.35L163.21,169.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M153.14,170.37l10.07-0.97c0,0-0.35,1.86,0.96,2.35l-11.1,0.81C153.07,172.56,152.18,171.3,153.14,170.37 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M169.84,169.11l-6.81,0.52c0,0,0.05-0.24,0.18-0.24c0.13,0,6.76-0.48,6.76-0.48l-0.02,0.19L169.84,169.11 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "164.17,171.75 170.17,170.61 170.11,170.45 163.72,171.68  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.43,223.57h-0.05c-0.32,0-0.58-0.26-0.57-0.58l0.86-37.56l2.54-0.3l-2.16,37.86 C95.02,223.31,94.76,223.57,94.43,223.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M79.64,223.57h-0.05c-0.32,0-0.58-0.26-0.57-0.58l0.86-37.56l2.54-0.3l-2.16,37.86 C80.23,223.31,79.96,223.57,79.64,223.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M120.45,223.57h0.05c0.32,0,0.58-0.26,0.57-0.58l-0.86-37.56l-2.54-0.3l2.16,37.86 C119.86,223.31,120.13,223.57,120.45,223.57z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.96,183.09v-25.74c0-4.53,3.65-8.2,8.15-8.2h18.44c4.5,0,8.15,3.67,8.15,8.2v26.72L77.96,183.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116,187.15H82.02c-2.24,0-4.06-1.82-4.06-4.06l0,0H116V187.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M120.05,187.15H93.56c-1.12,0-2.03-0.91-2.03-2.03l0,0c0-1.12,0.91-2.03,2.03-2.03h26.49 c1.12,0,2.03,0.91,2.03,2.03l0,0C122.08,186.25,121.17,187.15,120.05,187.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M105.79,139.64c0,0-1.54,1.31-1.88,4.72c-0.25,2.59,1.54,22.65,2.89,24.25c3.8,4.49,8.56,2.59,10.42,3.27 l1.76-1.58c0,0-6.18-4.56-6.65-6.05C110.51,158.52,111.63,141.81,105.79,139.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M104.68,123.27c0,0,0.1-3.68-4.75-4.4c-4.85-0.72-6.2,0.41-7.02,1.65c-0.83,1.24-2.37,6.29-2.22,8.31 c0.15,2.01,5.69,4.5,5.6,5.67C96.2,135.67,104.68,123.27,104.68,123.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.2,220.39c-0.16,1.24,1.54,1.61,3.51,1.78c1.97,0.17,1.36,0.56,4.05,1.16c2.69,0.6,3.8-0.12,4.01-0.48 c0.19-0.32-1.05-0.89-2.38-1.52c-0.17-0.08-0.33-0.16-0.5-0.24c-1.49-0.73-2.29-2.14-3.42-3.46c-1.07-1.25-1.99-5.17-1.99-5.17 l-3.65-0.94c0,0,0.91,3.53,1.22,5.03c0.18,0.88-0.17,1.85-0.47,2.59C127.42,219.55,127.25,219.96,127.2,220.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M130.71,222.18c1.97,0.17,1.36,0.56,4.05,1.16c2.69,0.6,3.8-0.12,4.01-0.48c0.19-0.32-1.05-0.89-2.38-1.52 l-0.02,0.02c0,0-1.93,0.59-4.11-0.1c-1.77-0.56-3.47-1.71-4.69-2.11c-0.16,0.4-0.33,0.81-0.38,1.25 C127.04,221.64,128.73,222,130.71,222.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M99.84,169.68c0,0,24.42,2.53,28.45,6.27c4.03,3.74,3.31,38.57,3.31,38.57c-0.63,0.65-1.09,0.64-2.08,0.56 c-0.95-0.07-2.89-0.89-2.89-0.89s-5.23-17.1-5.3-21.06c-0.07-3.96-0.89-10.68-2.55-11.08c-1.66-0.4-21.43,1.82-23.6-4.42 c-2.17-6.25,1.43-11.38,1.43-11.38L99.84,169.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M88.43,175.96c1.05,0.71,2.94,1.79,6.1,1.91c5.66,0.21,12.72-0.47,14.11-1.78c0.36-0.34,0.54-0.9,0.59-1.61 c0.15-2.17-0.88-5.74-1.58-8.7c-0.45-1.92-0.76-3.58-0.51-4.43c0.77-2.58,3.15-7.84,3.36-9.57c0.21-1.73-1.86-10.99-4.71-12.14 c-2.85-1.15-13.86,0-13.86,0c-4.3,0.87-4.48,10.04-3.05,17.85c0.04,0.2,0.07,0.4,0.11,0.6 C90.53,166.01,85.49,173.99,88.43,175.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M102.66,141.33c-0.08,0.5-1.45,1.32-4.4,0.54c-2.82-0.74-3.16-1.66-3.16-2.27c0-0.72,1.23-1.68,1.21-6.1 l0.34,0.07l5.68,1.13c0,0-0.13,1.79-0.13,3.47C102.2,139.59,102.78,140.49,102.66,141.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M102.33,134.7c0,0-0.13,1.79-0.13,3.47c-3.18-0.09-4.86-2.99-5.55-4.6L102.33,134.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M103.4,136.29c0,0-7.53,0.12-7.53-4.56c-0.01-4.69-0.98-7.83,3.83-8.11c4.81-0.28,5.74,1.51,6.12,3.07 C106.19,128.26,105.35,136.14,103.4,136.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M103.12,123.51c0,0-2.06,5.5-5.22,6.31c-3.16,0.81-4.53-0.03-4.53-0.03s2.43-1.93,2.93-5.29 C96.29,124.49,101.56,120.89,103.12,123.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M102.61,123.95c0,0,1.54,1.23,1.91,2.42c0.38,1.19,0.54,3.65,1.26,3.57c0,0,1.55-3.74-0.19-5.85 C103.74,121.85,102.61,123.95,102.61,123.95z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.85,221.42c-0.02,1.25,1.71,1.42,3.69,1.37c1.98-0.06,1.42,0.4,4.16,0.69 c2.74,0.29,3.77-0.55,3.93-0.94c0.15-0.34-1.15-0.76-2.53-1.24c-0.17-0.06-0.35-0.12-0.52-0.18c-1.56-0.56-2.51-1.86-3.78-3.05 c-1.21-1.12,1.45-6.54,1.45-6.54l-3.49-1.73c0,0-0.66,3.87-1.51,7.26c-0.22,0.87-0.94,2.32-1.16,3.08 C108.98,220.55,108.86,220.97,108.85,221.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M88.58,175.03c1.05,0.71,2.79,2.72,5.95,2.84c5.22-1.19,11.16-2.57,14.69-3.39 c0.15-2.17-0.88-5.74-1.58-8.7c-4.12,1.26-10.25-3.03-12.32-4.72c-2.17-1.78-2.1-7.71-2.1-7.71l-4.36,4.14 c0.04,0.2,0.07,0.4,0.11,0.6C90.53,166.01,85.64,173.06,88.58,175.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M112.54,222.78c1.98-0.06,1.42,0.4,4.16,0.69c2.74,0.29,3.77-0.55,3.93-0.94c0.15-0.34-1.15-0.76-2.53-1.24 l-0.02,0.02c0,0-1.85,0.81-4.09,0.37c-1.83-0.35-3.64-1.3-4.9-1.56c-0.12,0.42-0.24,0.84-0.24,1.28 C108.83,222.67,110.56,222.84,112.54,222.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M94.57,171.17c6.2-0.18,24.72,1.3,28.28,3.98c4.38,3.3-8.13,39.01-8.13,39.01s-1.45,0.14-1.91,0.09 c-1.99-0.22-2.8-0.83-2.8-0.83s0.05-21.02,1.51-25.04c1.35-3.71,2.18-5.03,0.49-5.25c-1.69-0.22-22.81,2.47-24.58-3.9 c-1.38-4.98,0.66-9.59,0.66-9.59S88.85,171.33,94.57,171.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M91.93,139.64c0,0-4.31,0.37-4.64,3.77c-0.25,2.59-2.13,20.92-0.78,22.52c3.8,4.49,16.46,5.44,18.32,6.12 l0.51-2.12c0,0-13.52-6.81-13.31-8.36C92.24,160.02,96.06,139.03,91.93,139.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M95.25,120.72c0,0,0.31-1.96-2.41-2.47c-2.72-0.51-2.77,5.28-3.07,6.67c-0.29,1.39,0.44,2.23,1.47,2.32 C92.28,127.32,95.25,120.72,95.25,120.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.49,169.83c0,0,3.85-1.09,4.77-0.83c0.92,0.25,4.06,2.33,3.62,2.9c-0.44,0.56-3.21-0.34-4.48-0.17 c-1.27,0.17-2.26,0.8-3.18,0.66c-0.92-0.14-1.88-0.5-1.88-0.5L105.49,169.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.49,169.83c0,0,1.88-0.97,2.42-1.52c0.07-0.07,0.18-0.05,0.23,0.03c0.14,0.23,0.28,0.66-0.38,1.1 C106.81,170.07,105.49,169.83,105.49,169.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M118.98,170.3c0,0,3.99,0.22,4.78,0.76c0.78,0.54,3.08,3.53,2.48,3.92c-0.6,0.39-2.93-1.36-4.19-1.61 c-1.26-0.25-2.4,0.02-3.22-0.4c-0.82-0.43-1.61-1.08-1.61-1.08L118.98,170.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M91.54,223.9H75.29c-0.78-0.95-0.49-4.47-0.38-5.62c0.02-0.23,0.04-0.37,0.04-0.37s5.55-4.44,6.31-1.04 c0.02,0.11,0.05,0.21,0.08,0.31c0.96,3.18,5.27,4.62,7.76,5.03C90.72,222.47,91.32,223.31,91.54,223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M47.19,171.09c0.59,0,27.84,5.12,32.35,10.7c2.25,2.79,2.59,34.98,2.59,34.98s-2.79,3.45-8.8,1.45 c0,0-4.41-22.03-4.09-28.71c0.09-1.85-18.62-0.27-22.04-1.15c-3.42-0.89-11.79-8.34-9.95-11.97 C39.09,172.76,47.19,171.09,47.19,171.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M66.92,169.58c0,0,1.74,1.5,3.53,1.93c1.02,0.24,2.01,0.52,2.6,0.79c1.62,0.74,4.69,4.06,4.4,4.39 c-0.92,1.06-4.6-1.7-5.31-1.5c-0.71,0.19,1.16,1.79,0.42,2.23c-0.39,0.23-1.11-1.15-1.79-1.35c-0.92-0.26-1.53-1.65-1.81-1.75 c-0.54-0.18-2.78-2.19-2.78-2.19L66.92,169.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M98.72,223.9H82.47c-0.78-0.95-0.49-4.47-0.38-5.62c0.02-0.23,0.04-0.37,0.04-0.37s5.55-4.44,6.31-1.04 c0.02,0.11,0.05,0.21,0.08,0.31c0.96,3.18,5.27,4.62,7.76,5.03C97.9,222.47,98.5,223.31,98.72,223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M55.22,171.09c0.59,0,27.84,5.12,32.35,10.7c2.25,2.79,2.59,34.98,2.59,34.98s-2.79,3.45-8.8,1.45 c0,0-4.41-22.03-4.09-28.71c0.09-1.85-18.62-0.27-22.04-1.15c-3.42-0.89-11.79-8.34-9.95-11.97 C47.12,172.76,55.22,171.09,55.22,171.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M53.52,137.97c-1.96-0.16-4.02-0.68-5.79-1.26c-2.22-0.72-4.01-1.77-2.86-3.8 c1.06-1.87,2.78-6.05,2.67-9.51l4.13,3.33l2.81,2.26c0,0-0.01,1.33-0.32,3.67c-0.06,0.43-0.12,0.89-0.2,1.38 c-0.06,0.4,0.12,0.79,0.46,1.01c0.02,0.01,0.04,0.03,0.06,0.04C55.88,135.96,55.16,138.11,53.52,137.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M54.47,128.44c0,0,0.14,0.48-0.1,2.27c-2.5-0.41-4.84-2.4-4.84-2.4c1.27-0.35,1.74-1.73,2.69-1.6 L54.47,128.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M56.79,128.84c0,0-9.63,1.6-10.53-4.41c-0.9-6.01-2.75-9.85,3.35-11.13c6.11-1.28,7.65,0.84,8.44,2.77 C58.84,118.01,59.27,128.27,56.79,128.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M59.47,113.42c0.41,1.45-0.69,3.21-2.55,3.79c-2.76,0.86-2.15,4.24-3.39,4.2 c-1.24-0.05-1.74-1.94-2.85-0.43c-0.95,1.29,0.79,2.83,0.67,3.54c-0.2,1.22-2.11,3.71-3.83,3.58c-1.72-0.12-4.93-8.29-4.29-10.82 c0.64-2.53,3.22-5.19,5.65-5.56c2.44-0.37,5.82,0.68,6.6,0.68C56.26,112.4,59.24,112.64,59.47,113.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M61.85,169.29c-0.16,1.39-0.45,2.33-0.91,2.64c-1.44,0.96-3.34,2.16-5.46,3.34 c-7.53,4.2-17.84,8.25-19.94,1.15c-2.46-8.33-0.84-23.98,1.57-33.7c1.39-5.6,5.24-11.48,7.84-11.47 c4.43,0.01,10.8,1.18,13.37,7.52c1,2.46,2.46,10.97,3.21,18.77C61.97,162.19,62.17,166.58,61.85,169.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M44.51,131.3l1-2.26c0,0,8.89,0.91,10.4,6.02C55.91,135.05,49.04,131.41,44.51,131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M61.85,169.29c-0.16,1.39-0.45,2.33-0.91,2.64c-1.44,0.96-3.34,2.16-5.46,3.34 c-2.22-1.35-6.77-4.56-7.83-8.35c-1.39-4.95-0.42-11.05-0.42-11.05L61.85,169.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M46.31,138.92c0,0,0.77,21.29,1.98,25.5c2.06,7.18,20.89,9.73,20.89,9.73s1.11-1.26,0.61-3.35 c0,0-11.26-8.87-11.58-10.56c-0.33-1.69,2.45-13.13-0.73-17.3C54.31,138.79,48.45,135.18,46.31,138.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M22.71,223.69l-0.06,0c-0.51-0.01-0.9-0.42-0.85-0.9l3.38-33.78l2.95,0.26l-4.86,33.96 C23.23,223.5,22.99,223.7,22.71,223.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40.12,223.69l-0.06,0c-0.51-0.01-0.9-0.42-0.85-0.9l3.38-33.78l2.95,0.26l-4.86,33.96 C40.64,223.5,40.4,223.7,40.12,223.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M72.8,223.69l0.06,0c0.51-0.01,0.9-0.42,0.85-0.9l-3.38-33.78l-2.95,0.26l4.86,33.96 C72.27,223.5,72.52,223.7,72.8,223.69z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.66,184.23l-3.21-28.21c-0.42-4.07,0.94-8.05,6.81-8.35l10.32-0.63c6.12-0.25,8.88,4.84,9.65,8.76 l6.13,31.01L23.66,184.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.42,189.51h43.75c1.49,0,2.7-1.22,2.7-2.7v0c0-1.49-1.22-2.7-2.7-2.7H23.71v2.7 C23.71,188.29,24.93,189.51,26.42,189.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.42,189.51h24.24c1.49,0,2.7-1.22,2.7-2.7v0c0-1.49-1.22-2.7-2.7-2.7H23.71v2.7 C23.71,188.29,24.93,189.51,26.42,189.51z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M417.38,225.15H10.12c-0.46,0-0.84-0.38-0.84-0.84l0,0c0-0.46,0.38-0.84,0.84-0.84h407.26 c0.46,0,0.84,0.38,0.84,0.84v0C418.21,224.77,417.84,225.15,417.38,225.15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88.6,98.53h-0.55c-4.94,0-8.98-4.04-8.98-8.98v0c0-4.94,4.04-8.98,8.98-8.98h0.55 c4.94,0,8.98,4.04,8.98,8.98v0C97.58,94.49,93.54,98.53,88.6,98.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M88.58,97.75h-0.5c-4.51,0-8.2-3.69-8.2-8.2v0c0-4.51,3.69-8.2,8.2-8.2h0.5c4.51,0,8.2,3.69,8.2,8.2v0 C96.78,94.06,93.09,97.75,88.58,97.75z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 88.32,
    cy: 82.99,
    r: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.03,83.53c0.1-0.19,0.34-0.25,0.52-0.15c0.19,0.1,0.25,0.34,0.15,0.52c-0.1,0.19-0.34,0.25-0.52,0.15 C91,83.95,90.93,83.72,91.03,83.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M93.68,85.64c0.18-0.11,0.42-0.06,0.53,0.11c0.11,0.18,0.06,0.42-0.11,0.53c-0.18,0.11-0.42,0.06-0.53-0.11 C93.45,85.99,93.51,85.75,93.68,85.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95,88.9c0.21,0,0.38,0.17,0.38,0.38c0,0.21-0.17,0.38-0.38,0.38c-0.21,0-0.38-0.17-0.38-0.38 C94.61,89.07,94.78,88.9,95,88.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 94.06,
    cy: 92.95,
    r: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.92,95.09c0.15,0.15,0.15,0.39,0,0.54s-0.39,0.15-0.54,0c-0.15-0.15-0.15-0.39,0-0.54 C91.53,94.94,91.77,94.94,91.92,95.09z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 88.32,
    cy: 96.34,
    r: 0.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M85.6,83.53c-0.1-0.19-0.34-0.25-0.52-0.15c-0.19,0.1-0.25,0.34-0.15,0.52c0.1,0.19,0.34,0.25,0.52,0.15 C85.64,83.95,85.7,83.72,85.6,83.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M82.95,85.64c-0.18-0.11-0.42-0.06-0.53,0.11c-0.11,0.18-0.06,0.42,0.11,0.53 c0.18,0.11,0.42,0.06,0.53-0.11C83.18,85.99,83.13,85.75,82.95,85.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M81.64,88.9c-0.21,0-0.38,0.17-0.38,0.38c0,0.21,0.17,0.38,0.38,0.38c0.21,0,0.38-0.17,0.38-0.38 C82.02,89.07,81.85,88.9,81.64,88.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 82.58,
    cy: 92.95,
    r: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.72,95.09c-0.15,0.15-0.15,0.39,0,0.54s0.39,0.15,0.54,0c0.15-0.15,0.15-0.39,0-0.54 C85.11,94.94,84.87,94.94,84.72,95.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88.22,89.28c0-0.21,0.17-0.38,0.38-0.38c0.21,0,0.38,0.17,0.38,0.38c0,0.21-0.17,0.38-0.38,0.38 C88.39,89.66,88.22,89.49,88.22,89.28z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.55,
    y: 84.49,
    className: "st7",
    width: 0.1,
    height: 4.79
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.21,
    y: 88.12,
    transform: "matrix(0.7866 -0.6175 0.6175 0.7866 -35.339 74.3004)",
    className: "st7",
    width: 3.23,
    height: 0.31
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.19b845e678af01758b9ff4d5c0068736.svg";
export { ForwardRef as ReactComponent };